module.exports = __webpack_public_path__ + "img/who1.0676c3f1.webp";